document.addEventListener("turbolinks:load", function() {
  editor = "";
  editor2 = "";

  if ($("#recommend_group_setting_element_css").length > 0) {
    editor = ace.edit("recommend_group_setting_element_css");
    editor.session.setMode("ace/mode/css");
    editor.setTheme("ace/theme/twilight");
  
    // タブのスペース数を設定
    editor.getSession().setTabSize(2);
  
    // セッションの変更時のイベントを監視
    editor.session.on('changeAnnotation', function() {
      let annotations = editor.session.getAnnotations() || [], i = len = annotations.length;
      while (i--) {
        if(/important/.test(annotations[i].text)) { // !importantに関する警告をチェック
          annotations.splice(i, 1);
        }
      }
      if (len > annotations.length) {
        editor.session.setAnnotations(annotations);
      }
    });
  }

  if ($("#recommend_group_setting_element_cart_opt_css").length > 0) {
    editor2 = ace.edit("recommend_group_setting_element_cart_opt_css");
    editor2.session.setMode("ace/mode/css");
    editor2.setTheme("ace/theme/twilight");
  
    // タブのスペース数を設定
    editor2.getSession().setTabSize(2);
  
    // セッションの変更時のイベントを監視
    editor2.session.on('changeAnnotation', function() {
      let annotations = editor2.session.getAnnotations() || [], i = len = annotations.length;
      while (i--) {
        if(/important/.test(annotations[i].text)) { // !importantに関する警告をチェック
          annotations.splice(i, 1);
        }
      }
      if (len > annotations.length) {
        editor2.session.setAnnotations(annotations);
      }
    });
  }
  

  $('.recommend_group_setting_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_group_setting_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.recommend_group_setting_slidedown_btn').fadeIn(0));
  });

  $('.recommend_group_setting_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_group_setting_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.recommend_group_setting_slideup_btn').fadeIn(0));
  });

  // ------------------------------------------------------------------------------------------------
  // レコメンド設定
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // レコメンド設定の切り替え
  // #################################################################
  $('.recommend_group_setting_selects').on('change', function () {
    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    if (recommend_group_setting_id == 'new') {
      $('.recommend_group_setting_set_wrapper_display').css('display', 'block');
      $('.recommend_group_setting_name_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_device_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_show_valid_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_display_count_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_url_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_excluded_url_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_element_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_design_css_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_design_custom_setting_wrapper').css('display', 'none');
      $('.recommend_group_setting_slider_detail_wrapper').css('display', 'none');
    } else {
      if (recommend_group_setting_type_data == "ITEM"){
        location.href = `/recommend_group_setting/detail_index?recommend_group_setting_id=${recommend_group_setting_id}&setting_type=${recommend_group_setting_type_data}`;
      } else {
        location.href = `/recommend_group_setting?recommend_group_setting_id=${recommend_group_setting_id}&setting_type=${recommend_group_setting_type_data}`;
      }
    }
  });
  // #################################################################
  // レコメンド設定の新規作成
  // #################################################################
  $('#recommend_group_setting_create').on('click', function () {
    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");
    const name = $('.recommend_group_setting_input').val();

    if (!name) {
      alert('設定名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/recommend_group_setting/create_recommend_group_setting',
      type: 'POST',
      data: {
        name: name,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('新規登録されました。');

        if (recommend_group_setting_type_data == "ITEM"){
          location.href = `/recommend_group_setting/detail_index?recommend_group_setting_id=${data.recommend_group_id}&device=${data.is_device}&setting_type=${recommend_group_setting_type_data}`;
        } else {
          location.href = `/recommend_group_setting?recommend_group_setting_id=${data.recommend_group_id}&device=${data.is_device}&setting_type=${recommend_group_setting_type_data}`;
        }
      }
    });
  });

  // #################################################################
  // レコメンド設定名の編集
  // #################################################################
  $('#recommend_group_setting_name_edit_btn').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");
    let name = $('.recommend_group_setting_name_val').val();

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/recommend_group_setting/save_recommend_group_setting_name',
      type: 'POST',
      data: {
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        recommend_group_setting_id: recommend_group_setting_id,
        name: name,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // レコメンド設定のデバイスの切り替え
  // #################################################################
  $('.recommend_group_setting_device_selects').on('change', function () {
    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    if (recommend_group_setting_type_data == "ITEM"){
      location.href = `/recommend_group_setting/detail_index?recommend_group_setting_id=${recommend_group_setting_id}&recommend_group_device_setting_id=${recommend_group_device_setting_id}&setting_type=${recommend_group_setting_type_data}`;
    } else if (recommend_group_setting_type_data == "USER") {
      location.href = `/recommend_group_setting?recommend_group_setting_id=${recommend_group_setting_id}&recommend_group_device_setting_id=${recommend_group_device_setting_id}&setting_type=${recommend_group_setting_type_data}`;
    } else if (recommend_group_setting_type_data == "CART"){
      location.href = `/recommend_group_setting/cart_index?recommend_group_setting_id=${recommend_group_setting_id}&recommend_group_device_setting_id=${recommend_group_device_setting_id}&setting_type=${recommend_group_setting_type_data}`;
    }
  });

  // #################################################################
  // レコメンド設定の公開設定
  // #################################################################
  $('.recommend_group_setting_show_valid_select_box').on('change', function (event) {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");
    let show_valid = $('.recommend_group_setting_show_valid_select_box:checked').val();

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    $.ajax({
      url: '/recommend_group_setting/save_recommend_group_setting_show_valid',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        show_valid: show_valid,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // レコメンド設定名の編集
  // #################################################################
  $('#recommend_group_setting_display_count_edit_btn').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");
    let display_count = $('.recommend_group_setting_display_count_val').val();

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    if (!display_count) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/recommend_group_setting/save_recommend_group_setting_display_count',
      type: 'POST',
      data: {
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        display_count: display_count,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 要素の挿入先の設定
  // #################################################################
  $('#recommend_group_setting_element_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let element_id_val = $('#element_id_input').val();
    let element_class_val = $('#element_class_input').val();
    let element_index_val = $('#element_index_input').val();
    let parent_id_val = $('#parent_id_input').val();
    let parent_class_val = $('#parent_class_input').val();
    let parent_index_val = $('#parent_index_input').val();
    let grand_id_val = $('#grand_id_input').val();
    let grand_class_val = $('#grand_class_input').val();
    let grand_index_val = $('#grand_index_input').val();
    let great_grand_id_val = $('#great_grand_id_input').val();
    let great_grand_class_val = $('#great_grand_class_input').val();
    let recommend_group_setting_element_placement = $('.recommend_group_setting_list .recommend_group_setting_placement option:selected').val();

    $.ajax({
      url: '/recommend_group_setting/create_recommend_group_setting_element',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        element_id: element_id_val,
        element_class: element_class_val,
        element_index: element_index_val,
        parent_id: parent_id_val,
        parent_class: parent_class_val,
        parent_index: parent_index_val,
        grand_id: grand_id_val,
        grand_class: grand_class_val,
        grand_index: grand_index_val,
        great_grand_id: great_grand_id_val,
        great_grand_class: great_grand_class_val,
        element_placement: recommend_group_setting_element_placement,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // スライダー詳細設定
  // #################################################################
  $('#recommend_group_setting_slider_detail_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let sw_navigation_flag_val = $('.recommend_group_setting_slider_detail_list .sw_navigation_flag_select option:selected').val();
    let sw_pagination_flag_val = $('.recommend_group_setting_slider_detail_list .sw_pagination_flag_select option:selected').val();
    let sw_slides_per_view_val = $('#sw_slides_per_view_input').val();
    let sw_slides_per_group_val = $('#sw_slides_per_group_input').val();
    let sw_grid_rows_val = $('#sw_grid_rows_input').val();
    let sw_space_between_val = $('#sw_space_between_input').val();
    let sw_loop_flag_val = $('.recommend_group_setting_slider_detail_list .sw_loop_flag_select option:selected').val();

    $.ajax({
      url: '/recommend_group_setting/create_recommend_group_setting_slider_detail',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        sw_navigation_flag: sw_navigation_flag_val,
        sw_pagination_flag: sw_pagination_flag_val,
        sw_slides_per_group: sw_slides_per_group_val,
        sw_slides_per_view: sw_slides_per_view_val,
        sw_grid_rows: sw_grid_rows_val,
        sw_space_between: sw_space_between_val,
        sw_loop_flag: sw_loop_flag_val,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // slider css設定
  // #################################################################
  $('#recommend_group_setting_element_css_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let css_val = editor.getValue();
    console.log(css_val);

    // let css_val = $('#recommend_group_setting_element_css').val();

    // 禁止された単語のリスト
    const forbiddenWords = ['<style>', '</style>', '<script>', '</script>', 'javascript'];

    // CSSの値に禁止された単語が含まれているかチェック
    let containsForbiddenWord = forbiddenWords.some(word => css_val.includes(word));

    if (containsForbiddenWord) {
        alert('不正なコードが混ざっています。');
        return;
    }

    $.ajax({
      url: '/recommend_group_setting/create_recommend_group_setting_css',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        css_val: css_val,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // slider css設定
  // #################################################################
  $('#recommend_group_setting_element_cart_opt_css_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let css_val = editor2.getValue();
    console.log(css_val);

    // let css_val = $('#recommend_group_setting_element_css').val();

    // 禁止された単語のリスト
    const forbiddenWords = ['<style>', '</style>', '<script>', '</script>', 'javascript'];

    // CSSの値に禁止された単語が含まれているかチェック
    let containsForbiddenWord = forbiddenWords.some(word => css_val.includes(word));

    if (containsForbiddenWord) {
        alert('不正なコードが混ざっています。');
        return;
    }

    $.ajax({
      url: '/recommend_group_setting/create_recommend_group_setting_cart_opt_css',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
        recommend_group_device_setting_id: recommend_group_device_setting_id,
        css_val: css_val,
        setting_type: recommend_group_setting_type_data
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // デザイン設定(共通部分)の設定
  // #################################################################
  $('#current_recommend_group_common_style_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let values = {
      'recommend_group_setting_id': Number(recommend_group_setting_id),
      'recommend_group_device_setting_id': recommend_group_device_setting_id,
      'setting_type': recommend_group_setting_type_data
    };

    $('.recommend_group_common_val').each(function() {
      let id = $(this).attr('id');
      let value = $(this).val();
      values[id] = value;
    });

    $.ajax({
      url: '/recommend_group_setting/update_recommend_group_common_style',
      type: 'POST',
      data: values,
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // デザイン設定(共通部分)の設定
  // #################################################################
  $('#current_recommend_group_slider_style_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let values = {
      'recommend_group_setting_id': Number(recommend_group_setting_id),
      'recommend_group_device_setting_id': recommend_group_device_setting_id,
      'setting_type': recommend_group_setting_type_data
    };

    $('.recommend_group_slider_val').each(function() {
      let id = $(this).attr('id');
      let value = $(this).val();
      values[id] = value;
    });

    $.ajax({
      url: '/recommend_group_setting/update_recommend_group_slider_style',
      type: 'POST',
      data: values,
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // デザイン設定(共通部分)の設定
  // #################################################################
  $('#current_recommend_group_part_style_set').on('click', function () {
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let recommend_group_device_setting_id = $('.recommend_group_setting_device_selects:checked').data("recommend_group_setting_id");

    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");

    let values = {
      'recommend_group_setting_id': Number(recommend_group_setting_id),
      'recommend_group_device_setting_id': recommend_group_device_setting_id,
      'setting_type': recommend_group_setting_type_data
    };

    $('.recommend_group_part_val').each(function() {
      let id = $(this).attr('id');
      let value = $(this).val();
      values[id] = value;
    });

    $.ajax({
      url: '/recommend_group_setting/update_recommend_group_part_style',
      type: 'POST',
      data: values,
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // レコメンド設定の表示URL設定
  // #################################################################
  $('#recommend_group_setting_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="recommend_group_setting_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="recommend_group_setting_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.recommend_group_setting_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.recommend_group_setting_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#recommend_group_setting_url_set').on('click', function () {
    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let urls = [];
    $('.recommend_group_setting_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/recommend_group_setting/set_recommend_group_setting_url',
      type: 'POST',
      data: {
        setting_type: recommend_group_setting_type_data,
        recommend_group_setting_id: recommend_group_setting_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  //  レコメンド設定の除外URL設定
  // #################################################################
  $('#recommend_group_setting_excluded_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="recommend_group_setting_excluded_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="recommend_group_setting_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.recommend_group_setting_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.recommend_group_setting_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#recommend_group_setting_excluded_url_set').on('click', function () {
    const recommend_group_setting_type_data = $(".recommend_group_setting_type_data").data("setting_type");
    let recommend_group_setting_id = $('.recommend_group_setting_selects option:selected').val();
    let urls = [];
    $('.recommend_group_setting_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/recommend_group_setting/set_recommend_group_setting_excluded_url',
      type: 'POST',
      data: {
        setting_type: recommend_group_setting_type_data,
        recommend_group_setting_id: recommend_group_setting_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });


  // ------------------------------------------------------------------------------------------------
  // レコメンド
  // ------------------------------------------------------------------------------------------------
  $('.recommend_metric_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_metric_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.recommend_metric_slidedown_btn').fadeIn(0));
  });

  $('.recommend_metric_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.recommend_metric_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.recommend_metric_slideup_btn').fadeIn(0));
  });

  // ------------------------------------------------------------------------------------------------
  // レコメンド
  // ------------------------------------------------------------------------------------------------
  function recommend_group_update_url() {
    const recommend_group_setting_id = $('#recommend_metric_selects option:selected').val();
    const gf = $('#recommend_metric_graph_pattern_select_input').val();
    const start_day = $('#recommend_metric_report_start_day').val();
    const end_day = $('#recommend_metric_report_end_day').val();
    const device = $('.recommend_metric_device_select').data("device");

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (recommend_group_setting_id !== 'none' && recommend_group_setting_id !== null && recommend_group_setting_id !== undefined) {
      params.set('recommend_group_setting_id', recommend_group_setting_id);
    } else {
      params.delete('recommend_group_setting_id');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1" || device == "2") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // レコメンドコメンドューの選択
  // #################################################################
  $('#recommend_metric_selects').on('change', function () {
    recommend_group_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.recommend_metric_graph_pattern_select_day, .recommend_metric_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#recommend_metric_graph_pattern_select_input').val(gf_value);
    recommend_group_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.recommend_metric_device_select_all, .recommend_metric_device_select_pc, .recommend_metric_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.recommend_metric_device_select').data("device", device);
    recommend_group_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#recommend_metric_report_start_day, #recommend_metric_report_end_day').on('change', function () {
    recommend_group_update_url();
  });

  // #################################################################
  // レコメンドグデータのみの削除
  // #################################################################
  $('.delete_recommend_metric_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const recommend_group_setting_id = $('#recommend_metric_selects option:selected').val();

    $.ajax({
      url: '/recommend_group_report/delete_recommend_group_log',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // レコメンドグデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_recommend_metric_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const recommend_group_setting_id = $('#recommend_metric_selects option:selected').val();

    $.ajax({
      url: '/recommend_group_report/delete_recommend_group_log_and_related_data',
      type: 'POST',
      data: {
        recommend_group_setting_id: recommend_group_setting_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/recommend_group_report/index';
      }
    });
  });

  // #################################################################
  // レコメンドポートのcsv出力
  // #################################################################
  $('#download_recommend_metric_csv').on('click', function () {
    const recommend_group_setting_id = $('#recommend_metric_selects option:selected').val();
    const month = $('#ua_recommend_metric_month_selects option:selected').val();

    let href = '/download_recommend_metric_csv';

    href += `?recommend_group_setting_id=${recommend_group_setting_id}`;
    href += `&m=${month}`;
    location.href = href;
  });

  $('#ua_recommend_metric_month_selects').on('change', function () {
    let month = $('#ua_recommend_metric_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      location.reload();
    }
  });
});